export default {_name:'button.listItem',module:'Field',view:'Element/Button/ListItem',options:{xs:12,ms:12},children:[]}